<div style="display: flex;height: 90vh; width:100vw;justify-content:center;align-items: center;" >
  <app-fifth-circle style="width: 70vh;"></app-fifth-circle>
</div>  